module.exports = __webpack_public_path__ + "img/spin_btn.9a1d6244.png";